<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_transferSyllables') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' + parameters.theme) }}
        game-preview-setting(v-if="parameters.amountOfExamples && !parameters.infinityAmountOfExamples")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gamePlayBox_tip') }}
            span(slot="value") {{  parameters.isHintEnabled ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('common.common_gameName_vocabularyWords') }}
            span(slot="value") {{  parameters.difficultWords ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
</template>

<script>
/*eslint-disable*/
import GamePreviewSettings from './GamePreviewSettings.vue'
import GamePreviewSetting from './GamePreviewSetting.vue'
import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

export default {
    props: ['parameters', 'exerciseId', 'type'],
    mixins: [GamePreviewMixin],
    components: {
        GamePreviewSettings,
        GamePreviewSetting
    },
    computed: {
        timeLimit() {
            return (
                this.parameters.timeLimit +
                ' ' +
                this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit)
            );
        },
    }
}
</script>
